import { useMemo } from "react";

import { useCurrentStateAndParams } from "@uirouter/react";
import dayjs from "dayjs";

import {
    getCalendarMaxDailyDate,
    getCalendarMinDailyDate,
} from "app/pages/digital-marketing/monitor-and-protect/services/date-range-utils";
import { useTranslation } from "pro-features/components/WithTranslation";
import { proNavigator } from "single-spa/react-app/ProNavigator";

import { ROUTES } from "../../../../app/keywords/constants";
import { TRADEMARK_ROUTES } from "../../../../app/trademark/constants";
import { getMonitorAndProtectConfig } from "../../../data/component-config/component-config";
import { useMonitorAndProtectDataAndParams } from "../../../hooks/navigations";
import DurationSelector from "../components/duration/DurationSelectorSimple";
import type { IFilter } from "../FiltersBar";

import { getAdsPagePresets, getDefaultPresets } from "./duration-presets";

const ALLOWED_PAGES = [ROUTES.ADS.stateName, TRADEMARK_ROUTES.VIOLATIONS.stateName];

const DurationFilterItem = () => {
    const translate = useTranslation();
    const routeParams = useMonitorAndProtectDataAndParams();
    const config = getMonitorAndProtectConfig();
    const { state } = useCurrentStateAndParams();

    const isAllowedPage = !!state.name && ALLOWED_PAGES.includes(state.name);
    const isDisabled = !isAllowedPage;

    const defaultPresets = useMemo(
        () =>
            getDefaultPresets({
                translate,
                windowStartDate: config.windowStartDate,
                windowEndDate: config.windowEndDate,
            }),
        [translate, config.windowStartDate, config.windowEndDate],
    );

    const adsPresets = useMemo(() => getAdsPagePresets(translate), [translate]);

    const minDate = isAllowedPage ? getCalendarMinDailyDate(28) : dayjs().subtract(1, "year");
    const maxDate = dayjs().endOf("day");
    const maxDailyDate = getCalendarMaxDailyDate();

    return (
        <DurationSelector
            key={isAllowedPage ? "daily" : "monthly"}
            minDate={minDate}
            maxDate={maxDate}
            minDailyDate={isAllowedPage ? minDate : undefined}
            maxDailyDate={isAllowedPage ? maxDailyDate : undefined}
            isDisabled={isDisabled}
            isDaily={isAllowedPage}
            isWeeklyDataAvailable={isAllowedPage}
            height="60px"
            presets={isAllowedPage ? undefined : defaultPresets}
            weeklyPresets={isAllowedPage ? adsPresets : undefined}
            initialPreset={routeParams.duration}
            initialComparedDuration={false}
            onSubmit={(duration) => proNavigator.updateQueryParams({ duration }, { reload: false })}
            componentConfigId="Home"
        />
    );
};

export const durationFilterConfigItem: IFilter = {
    id: "duration",
    filter: <DurationFilterItem />,
};
